window.addEventListener('DOMContentLoaded', () => {
	lazyAppeared();
	selectBtnLocation();
});

//チェックボックスの値を配列に格納する関数
const storeCheckBoxValue = (name) =>{
	let valueArray = [];
	document.getElementsByName(name).forEach(check =>{
		if(check.checked) {
			valueArray.push(check.value);
		}
	});
	return valueArray;
}

//指定の要素ののクラスを取り除く関数
const initElements = ( elements , classLabel ) => {
	elements.forEach(element => {
		element.classList.remove(classLabel);
	});
}

//カテゴリのボタンをクリックすると背景色が切り替わる処理
document.querySelectorAll(".brands-checkbox").forEach($checkBox =>{
	$checkBox.addEventListener("change",e => {
		e.currentTarget.classList.toggle("is-checked");
	});
});

//カテゴリのボタン内のチェックボックスの値を取得して値を配列に格納し、
//格納した配列をコールバック関数に投げる処理
const $brands_cats = document.getElementsByName("brands-cat");
for(let i = 0 ; i < $brands_cats.length ; i ++ ) {
	$brands_cats[i].addEventListener('change' , () => {
		let brands_cats_array = [];
		for (let i = 0; i < $brands_cats.length; i++) {
			if ( $brands_cats[i].checked) {
				brands_cats_array.push($brands_cats[i].value);
			}
		}
		brandsFilter(brands_cats_array);
	});
}
//引数の配列の値を要素内のIDと比較して、カテゴリの表示非表示を切り替える処理
//引数の配列がからの場合は全てのカテゴリを表示させる
const brandsFilter = (array) => {

	const $brands_cat_sections = document.querySelectorAll(".brands-cat-section");
	const $targets = document.querySelectorAll(".is-target");

	//初期化
	initElements( $brands_cat_sections , "is-checked");
	initElements( $targets , "is-ignition");
	console.log(array.length);
	if(array.length > 0 ) {
		//id属性が配列の値と同じの要素にis-brands-activeを付与
		for(let i = 0; i < array.length ; i++) {
			$brands_cat_sections.forEach(element => {
				if(element.getAttribute('id') === array[i]) {
					setTimeout(()=> {
						element.classList.add("is-brands-active");
						element.classList.add("is-checked");
					},500)
					lazyAppeared();
				} else if( element.classList.contains("is-checked") ) {
					lazyAppeared();
				} else {
					element.classList.remove("is-brands-active");
					lazyAppeared();
				}
			})
		}
	} else {
		console.log($brands_cat_sections);
		//チェックボックスが空の場合はすべての要素を表示
		$brands_cat_sections.forEach(element  => {
			element.classList.add("is-brands-active");
			element.classList.add("is-checked");
			lazyAppeared();
		});
	}
}

//遅延表示の処理
const lazyAppeared = () => {
	const targets = document.querySelectorAll('.is-target');
	const brandsObserver = new IntersectionObserver( entries => {
		entries.forEach(entry =>{
			if (entry.intersectionRatio > 0) {
				entry.target.classList.add("is-ignition");
				brandsObserver.unobserve(entry.target);
			}
		})
	}, {
		rootMargin: '-100px 0px'
	});
	targets.forEach(target => {
		brandsObserver.observe(target);
	});
}


/**
 * ボタンを押すと選択したセレクトメニューの
 * 値(value)のURLにリダイレクトする処理
 */
function selectBtnLocation() {
	$('.btn-select-location').on('click',function(){
		let id = $(this).attr('id');
		let location_url = $('select[name=' + id +']').val();
		if(location_url) {
			dataLayer.push({
				event: 'ourbrands_location',
				brands_location_url :location_url,
				// 計測が済んだあと、または計測が済んでいないが3000ミリ秒経過すると呼ばれる
				eventCallback : function() {
					window.location.href = location_url;
				},
				eventTimeout: 3000
			});
		}
	});
}
